import Vue from "vue";

Vue.component('toggle-switch', {
    props: ['values', 'selected', 'default'],
    data() {
        return {
            selection: this.selected
        };
    },    
    methods: {
        changeSelectVal: function (val) {
            this.selection = val;
            this.$emit('update:selected', val);
        }
    },
    template: `
        <div class="btn-group">
            <button type="button" 
                v-for="(val, key) in values"
                @click="changeSelectVal(key)"
                :class="['button', { 'is-primary': selection === key, 'is-light': selection !== key }]"
            >{{ val }}</button>
        </div>
    `
});